import { useWatch } from 'react-hook-form';

import { BindingCreator } from '@dreryk/react-common';
import { Textarea } from '@dreryk/react-components';

import { referralToPsychiatricHospitalTranslationKeys } from '../../../../translations';
import { ReferralToPsychiatricHospitalFormController } from '../../referralToPsychiatricHospitalForm.types';

import { TwoPagePrintNotification } from './TwoPagePrintNotification';

const SHORT_MAX_LENGTH = 400;
const EXTENDED_MAX_LENGTH = 2200;
const OTHER_JUSTIFYING_INFORMATION_FIELD_NAME = 'otherJustifyingInformation';

type OtherJustifyingInformationFormBeanPart = {
   [OTHER_JUSTIFYING_INFORMATION_FIELD_NAME]: string | null;
};
type OtherJustifyingInformationProps = {
   readonly register: BindingCreator<OtherJustifyingInformationFormBeanPart>;
   readonly control: ReferralToPsychiatricHospitalFormController['control'];
};

export const OtherJustifyingInformationTextarea = (props: OtherJustifyingInformationProps): JSX.Element => {
   const currentValue =
      useWatch<string | null>({ control: props.control, name: OTHER_JUSTIFYING_INFORMATION_FIELD_NAME }) ?? '';

   const extendedMode = currentValue.length > SHORT_MAX_LENGTH;
   const effectiveMaxLength = extendedMode ? EXTENDED_MAX_LENGTH : SHORT_MAX_LENGTH;
   const counterThreshold: number | undefined = extendedMode ? 0 : undefined;

   return (
      <Textarea
         rows={3}
         maxRows={5}
         maxLength={effectiveMaxLength}
         counterThreshold={counterThreshold}
         focus={false}
         label={referralToPsychiatricHospitalTranslationKeys.otherJustifyingInformation}
         controller={props.register(OTHER_JUSTIFYING_INFORMATION_FIELD_NAME)}
         placeholder={referralToPsychiatricHospitalTranslationKeys.fillOtherJustifyingInformation}
         testId={'otherJustifyingInformation'}
         footerContent={extendedMode ? <TwoPagePrintNotification /> : null}
         bottomRightElement={
            <Textarea.ModalView
               onChange={(value) => props.control.setValue(OTHER_JUSTIFYING_INFORMATION_FIELD_NAME, value)}
               initialValue={() => props.control.getValues(OTHER_JUSTIFYING_INFORMATION_FIELD_NAME) ?? ''}
               placeholder={referralToPsychiatricHospitalTranslationKeys.fillOtherJustifyingInformation}
               label={referralToPsychiatricHospitalTranslationKeys.otherJustifyingInformation}
               maxLength={effectiveMaxLength}
               counterThreshold={counterThreshold}
               bottomRightElement={extendedMode ? <TwoPagePrintNotification /> : null}
            />
         }
      />
   );
};
